module.exports = __webpack_public_path__ + "img/apple_pay_logo_white.c7a79d18.svg";